import { Button, Form, Modal, Rate, Space } from "antd";
import TextArea from "antd/es/input/TextArea";

import generateRes from "../../../assets/svg/generate-response.svg";
import FeatureComingSoon from "../../../common/FeatureComingSoon";
import { useEffect } from "react";

const ReplyToReviewForm = ({ isOpen, handleCancel, initialValues }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      response:
        "Thank you for your feedback! We're glad to hear about your experience at our property and appreciate your time in sharing it with us. We look forward to welcoming you back soon!",
    });
  }, [form]);

  return (
    <Modal
      title={
        <div
          className="heading24px text-color-1C1C1C roboto-medium"
          style={{ padding: "20px 24px 10px" }}
        >
          {initialValues?.responseStatus === "REPLIED"
            ? "Edit Response"
            : "Reply to Review"}
        </div>
      }
      className="delete-popup"
      open={isOpen}
      centered
      footer={null}
      onOk={() => {
        handleCancel();
        form.resetFields();
      }}
      onCancel={() => {
        handleCancel();
        form.resetFields();
      }}
    >
      <Form
        form={form}
        layout="vertical"
        style={{ padding: "20px 24px 10px" }}
        onFinish={() => handleCancel()}
      >
        <div className="text-color-848484 mb30 bg-muted p10px rounded heading13px">
          <div className="d-flex mb10 fw-bold align-items-center justify-content-between">
            {initialValues?.authorName}
            <Rate
              allowHalf
              defaultValue={initialValues?.rating}
              disabled
              style={{ fontSize: "13px" }}
            />
          </div>
          <div>{initialValues?.reviewText}</div>
        </div>
        <Form.Item
          label="Your Response"
          name="response"
          className="mb0"
          rules={[{ required: true, message: "Please enter your response." }]}
        >
          <TextArea rows={4} placeholder="Write your response here..." />
        </Form.Item>
        <FeatureComingSoon>
          <Button
            className="mt10 mb30 generate-response"
            onClick={handleCancel}
          >
            <img src={generateRes} alt="" style={{ width: 20, height: 20 }} />
            Generate Response
          </Button>
        </FeatureComingSoon>

        <Form.Item>
          <Space className="d-flex align-items-center justify-content-end">
            <Button
              className="secondary-btn"
              onClick={() => {
                handleCancel();
                form.resetFields();
              }}
            >
              Cancel
            </Button>
            <FeatureComingSoon>
              <Button type="primary" className="theme-btn" htmlType="submit">
                {initialValues?.responseStatus === "REPLIED"
                  ? "Update"
                  : "Submit"}{" "}
                Response
              </Button>
            </FeatureComingSoon>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ReplyToReviewForm;
